import React, { useEffect, useRef, useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { useForm } from "react-hook-form";
import { ToastContainer } from 'react-toastify';
import swal from 'sweetalert';
import HeaderDashboard from '../../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import Sidebar from '../../Components/DashboardComponent/sidebar/Sidebar';
import Loader from '../../Components/Loader';
import HttpHelper from '../../service/httpService';
import DashboardWrapper from './DashboardWrapper';
import { RxCross1, RxCross2 } from 'react-icons/rx';
import { hasAddPermission, hasDeletePermission, hasEditPermission, hasReadPermission, initilizeUserInfo } from "../../service/userService";

const SecurityObjectName = 'Website.JobListing';

const DashboardJobListing = (props) => {

    const [hasReadPermissionUser, setHasReadPermissionUser] = useState('');
    const [hasAddPermissionUser, setHasAddPermissionUser] = useState('');
    const [hasEditPermissionUser, setHasEditPermissionUser] = useState('');
    const [hasDeletePermissionUser, setHasDeletePermissionUser] = useState('');

    const getAllPermission = () => {
        setHasReadPermissionUser(hasReadPermission(SecurityObjectName));
        setHasAddPermissionUser(hasAddPermission(SecurityObjectName));
        setHasEditPermissionUser(hasEditPermission(SecurityObjectName));
        setHasDeletePermissionUser(hasDeletePermission(SecurityObjectName));
    }

    const [popupAddEdit, setPopupAddEdit] = useState(false);
    const [loaderApi, setLoaderApi] = useState(false);

    const [jobListing, setJobListing] = useState({});
    const [showLoader, setShowLoader] = useState(false);
    const { register, handleSubmit, watch, reset, formState: { errors }, setValue, clearErrors } = useForm({});
    const formRef = useRef();
    const [isEditing, setIsEditing] = useState(false);
    const AccordianHandle = useRef();
    const [accordianStatus, setAccordianStatus] = useState('0');
    const [jobListingIdUpdate, setJobListingIdUpdate] = useState('');
    const [rowVersion, setRowVersion] = useState('');

    const onSubmit = async (data, event) => {
        setLoaderApi(true);
        if (isEditing == true) {
            JobListingUpdate(data)
        } else {
            JobListingAdd(data)
        }
    };

    const JobListingAdd = async (data) => {
        await HttpHelper.post("JobListing", data).then((response) => {
            setLoaderApi(false);
            setPopupAddEdit(false);
            props.showToast('success', 'Record Added Succesfully');
            BlankFillDetails();
            GetJobListing();
        }).catch((error) => {
            if (imageUpdate === true) {
                DeleteUploadedFile(data.FileId)
            }
            console.log(error);
        })
    }
    const JobListingUpdate = async (data) => {
        Object.assign(data,
            { jobListingId: jobListingIdUpdate },
            { rowVersion: rowVersion },
        );

        await HttpHelper.put("JobListing", data).then((response) => {
            setLoaderApi(false);
            setPopupAddEdit(false);
            props.showToast('success', 'Record Updated Succesfully');
            BlankFillDetails();
            GetJobListing();
        }).catch((error) => {
            console.log(error);
        })
    }
    const GetJobListing = async (data) => {
        setLoaderApi(true);
        await HttpHelper.get("JobListing", data).then((response) => {
            setJobListing(response.data.data);
            BlankFillDetails();
            getAllPermission();
            setIsEditing(true);
            setLoaderApi(false);
        }).catch((error) => {
            console.log(error);
        })

    }
    const UpdateEditJobListing = async (elem) => {

        setPopupAddEdit(true);
        setLoaderApi(true);

        setIsEditing(true);
        setShowLoader(true);
        await HttpHelper.get("JobListing/" + elem).then((response) => {
            setValue('Title', response.data.title);
            setValue('Location', response.data.location);
            setValue('NumberOfPositions', response.data.numberOfPositions);
            setValue('JobType', response.data.jobType);
            setValue('Description', response.data.description);
            setValue('MinimumQualifications', response.data.minimumQualifications);
            setValue('ContactInfo', response.data.contactInfo);
            setValue('OpenDate', response.data.openDate);
            setValue('CloseDate', response.data.closeDate);
            setValue('URL', response.data.url);
            setShowLoader(false);
            accordianStatusHandle('1');
            setJobListingIdUpdate(response.data.jobListingId);
            setRowVersion(response.data.rowVersion);

            setPopupAddEdit(true);
            setLoaderApi(false);

        }).catch((error) => {
            setShowLoader(false);
            console.log(error);
        })
    }
    const DeleteJobListingById = (id) => {
        swal("Are you sure, you want to delete this KeyFeature?", { buttons: ["Cancel", "Yes"] })
            .then(async (willDelete) => {
                if (willDelete) {
                    setIsEditing(false);
                    formRef.current.reset();
                    await HttpHelper.delete("JobListing/" + id).then((response) => {
                        props.showToast('success', 'Job Listing Deleted successfully');
                        GetJobListing();
                    }).catch((error) => {
                        props.showToast('error', error.response.data);
                        console.log(error);
                    })
                }
            }
            );
    }
    const BlankFillDetails = () => {
        setIsEditing(false)
        setValue('Title', '');
        setValue('Location', '');
        setValue('NumberOfPositions', '')
        setValue('JobType', '');
        setValue('Description', '');
        setValue('MinimumQualifications', '');
        setValue('ContactInfo', '');
        setValue('OpenDate', '');
        setValue('CloseDate', '');
        setValue('URL', '');
        setJobListingIdUpdate('');
        setRowVersion('');
    }
    const accordianStatusHandle = (elem) => {

        if (elem === undefined) {
            if (accordianStatus === '0') {
                setAccordianStatus('1');
            } else {
                setAccordianStatus('0');
            }
        } else {
            setAccordianStatus(elem);
        }
    }
    useEffect(() => {
        GetJobListing();
        setIsEditing(true);
    }, []);

    return (
        <>
            <DashboardWrapper>
                <ToastContainer />
                <div className="DashboardWrapperChild">
                    <Sidebar />
                    <div className="contentWrapper">
                        <HeaderDashboard title="Job Listing" />
                        <div className="container-fluid mt-80 p-0">
                            <div className="row">
                                {hasAddPermissionUser == true ? <div className="col-auto">
                                    {isEditing === true ? <button onClick={() => {
                                        setPopupAddEdit(true);
                                        BlankFillDetails();
                                        accordianStatusHandle('1');
                                    }} className="btn btnSave">Add Job Listing</button> : ''}
                                </div> : ''}
                                <div className="col-md-12 mb-2">
                                </div>


                                {hasAddPermissionUser == true && loaderApi == false ? <div className="row">
                                    <div className="cardBox cardTableWrapperDashboard cardTableGridNewDesign">
                                        <table className="table tableCustomized table-striped">
                                            <thead>
                                                <tr>
                                                    <th>
                                                        #
                                                    </th>
                                                    <th>
                                                        Title
                                                    </th>
                                                    <th>
                                                        Minimum Qualification
                                                    </th>
                                                    <th>
                                                        Location
                                                    </th>

                                                    <th>
                                                        Job Type
                                                    </th>
                                                    <th style={{ verticalAlign: 'center', textAlign: 'center' }}>
                                                        Action
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    jobListing.length > 0 && jobListing.map((e, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>{e.title}</td>
                                                                <td>{e.minimumQualifications}</td>
                                                                <td>{e.location}</td>
                                                                <td>{e.jobType}</td>
                                                                <td>
                                                                    {

                                                                        hasEditPermissionUser == true ?
                                                                            <span className="mr-5">
                                                                                <svg onClick={() => UpdateEditJobListing(e.primaryKeyEncrypted)} xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#000" className="bi bi-pen" viewBox="0 0 16 16">
                                                                                    <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z" />
                                                                                </svg>
                                                                            </span> : ''
                                                                    }
                                                                    {

                                                                        hasDeletePermissionUser == true ?
                                                                            <span>
                                                                                <svg onClick={() => DeleteJobListingById(e.jobListingId)} xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#000" className="bi bi-trash" viewBox="0 0 16 16">
                                                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
                                                                                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
                                                                                </svg>
                                                                            </span> : ''
                                                                    }
                                                                </td>
                                                            </tr>);
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                        <div className="cardBox cardTableWrapperDashboard cardTableGridNewDesign">


                                        </div>
                                    </div>
                                </div> : loaderApi == false && hasAddPermissionUser == false ? <div className="NoPermission">Don't Have Permisiion</div> : <div className="loaderApi">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                        <g fill="none" fill-rule="evenodd">
                                            <g transform="translate(1 1)" stroke-width="2">
                                                <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                                <path d="M36 18c0-9.94-8.06-18-18-18">
                                                    <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                                </path>
                                            </g>
                                        </g>
                                    </svg>
                                </div>}
                                <Accordion className="d-none" defaultActiveKey="0" activeKey={accordianStatus} ref={AccordianHandle}>
                                    {hasReadPermissionUser == true ? <Accordion.Item eventKey="0" onClick={() => {
                                        accordianStatusHandle();
                                    }}>
                                        <Accordion.Header>Job Listing Grid</Accordion.Header>
                                        <Accordion.Body onClick={(e) => {
                                            e.stopPropagation();
                                        }} className="row" style={{ padding: '0px 15px' }}>
                                            <div className="col-md-12 mb-5 mt-5">
                                                <div className="listingWrapper">
                                                    <div className="serialNo">
                                                        S no.
                                                    </div>
                                                    <div className="title">
                                                        Title
                                                    </div>
                                                    <div className="minimumQualifications">
                                                        Minimum Qualifications
                                                    </div>
                                                    <div className="location">
                                                        Location
                                                    </div>
                                                    <div className="jobtype">
                                                        Job Type
                                                    </div>
                                                    <div className="action">
                                                        Actions
                                                    </div>
                                                </div>
                                                {jobListing.length > 0 && jobListing.map((e, index) => {
                                                    return (<div className="listingWrapper list">
                                                        <div className="serialNo">
                                                            <span className="mr-3">{index + 1} </span>
                                                        </div>
                                                        <div className="headingGrid">
                                                            <span className="mb-0">{e.title}</span>
                                                        </div>
                                                        <div className="headingGrid">
                                                            <span className="mb-0">{e.minimumQualifications}</span>
                                                        </div>
                                                        <div className="headingGrid">
                                                            <span className="mb-0">{e.location}</span>
                                                        </div>
                                                        <div className="headingGrid">
                                                            <span className="mb-0">{e.jobType}</span>
                                                        </div>
                                                        <div className="editIcons">
                                                            {hasEditPermissionUser == true ? <svg onClick={() => UpdateEditJobListing(e.primaryKeyEncrypted)} xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#000" className="bi bi-pen" viewBox="0 0 16 16">
                                                                <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z" />
                                                            </svg> : ''}
                                                            {hasDeletePermissionUser == true ? <svg onClick={() => DeleteJobListingById(e.jobListingId)} xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#000" className="bi bi-trash" viewBox="0 0 16 16">
                                                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
                                                                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
                                                            </svg> : ''}
                                                        </div>
                                                    </div>)
                                                })}
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item> : ''}
                                    {hasEditPermissionUser || hasAddPermissionUser ? <Accordion.Item eventKey="1" onClick={() => {
                                        accordianStatusHandle();
                                    }}>
                                        <Accordion.Header>{isEditing === true ? "Update" : "Add"} Job Listing</Accordion.Header>
                                        <Accordion.Body onClick={(e) => {
                                            e.stopPropagation();
                                        }}>
                                            <div className="col-md-12 mb-2">
                                                {showLoader === true ? <Loader show={showLoader} height="" /> : <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
                                                    <div className="cardBox cardTableWrapperDashboard">
                                                        <h4>{isEditing === true ? "Update Job Listing" : "Create Job Listing"}</h4>
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <label>Title : <span class="requiredAstric"> *</span></label>
                                                                <input type="text"  {...register("Title", { required: true })} className="border mb-2" placeholder="Title" aria-invalid={errors.Title ? "true" : "false"} />
                                                                {errors.Title?.type === 'required' && <p className="text-danger" role="alert"> Title is required</p>}
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label>Location : <span class="requiredAstric"> *</span></label>
                                                                <input type="text"  {...register("Location", { required: true })} className="border mb-2" placeholder="Location" aria-invalid={errors.Location ? "true" : "false"} />
                                                                {errors.Location?.type === 'required' && <p className="text-danger" role="alert"> Location is required</p>}
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label>Number Of Positions : <span class="requiredAstric"> *</span></label>
                                                                <input type="text"  {...register("NumberOfPositions", { required: true })} className="border mb-2" placeholder="Number Of Positions" aria-invalid={errors.NumberOfPositions ? "true" : "false"} />
                                                                {errors.NumberOfPositions?.type === 'required' && <p className="text-danger" role="alert"> Number Of Positions is required</p>}
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label>Job Type : <span class="requiredAstric"> *</span></label>
                                                                <input type="text"  {...register("JobType", { required: true })} className="border mb-2" placeholder="JobType" aria-invalid={errors.JobType ? "true" : "false"} />
                                                                {errors.JobType?.type === 'required' && <p className="text-danger" role="alert"> Job Type is required</p>}
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label>Minimum Qualifications : <span class="requiredAstric"> *</span></label>
                                                                <input type="text"  {...register("MinimumQualifications", { required: true })} className="border mb-2" placeholder="Minimum Qualifications" aria-invalid={errors.MinimumQualifications ? "true" : "false"} />
                                                                {errors.MinimumQualifications?.type === 'required' && <p className="text-danger" role="alert"> Minimum Qualifications is required</p>}
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label>Contact Info : <span class="requiredAstric"> *</span></label>
                                                                <input type="text"  {...register("ContactInfo", { required: true })} className="border mb-2" placeholder="Contact Info" aria-invalid={errors.ContactInfo ? "true" : "false"} />
                                                                {errors.ContactInfo?.type === 'required' && <p className="text-danger" role="alert"> Contact Info is required</p>}
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label>Open Date : {isEditing === true ? < span class="requiredAstric"> *</span> : ''}</label>
                                                                <input type="date" className="border col-md-12" {...register("OpenDate", { required: true })} placeholder="Open Date"></input>
                                                                {errors.OpenDate?.type === 'required' && <p className="text-danger" role="alert"> OpenDate is required</p>}
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label>Close Date : {isEditing === true ? < span class="requiredAstric"> *</span> : ''}</label>
                                                                <input type="date" className="border col-md-12" {...register("CloseDate", { required: true })} placeholder="Close Date"></input>
                                                                {errors.CloseDate?.type === 'required' && <p className="text-danger" role="alert"> Close Date is required</p>}
                                                            </div>
                                                            <div className="col-md-6">
                                                                <label>Url : <span class="requiredAstric"> *</span></label>
                                                                <input type="text"  {...register("URL", { required: true })} className="border mb-2" placeholder="URL" aria-invalid={errors.URL ? "true" : "false"} />
                                                                {errors.URL?.type === 'required' && <p className="text-danger" role="alert"> URL is required</p>}
                                                            </div>
                                                            <div className="col-md-12">
                                                                <label>Description : {isEditing === true ? < span class="requiredAstric"> *</span> : ''}</label>
                                                                <textarea className="border" {...register("Description", { required: true })} placeholder="Description"></textarea>
                                                                {errors.Description?.type === 'required' && <p className="text-danger" role="alert"> Description is required</p>}
                                                            </div>
                                                            <button className="btn btnSave mt-2">Save</button>
                                                        </div>
                                                    </div>
                                                </form>}
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item> : ''}
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </div>

                {hasAddPermissionUser || hasEditPermissionUser ? <div className="popupEditAndAddFormWrapper" style={{ right: `${popupAddEdit == true ? '0' : '-100%'}` }}>
                    <div className="popupEditAndAddForm">
                        <div className="popupEditAndAddFormCloseButton" onClick={() => {
                            setPopupAddEdit(false);
                            setIsEditing(true);
                        }} >
                            <RxCross2 />
                        </div>

                        {loaderApi == true ? <div className="loaderApi">
                            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                <g fill="none" fill-rule="evenodd">
                                    <g transform="translate(1 1)" stroke-width="2">
                                        <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                        <path d="M36 18c0-9.94-8.06-18-18-18">
                                            <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                        </path>
                                    </g>
                                </g>
                            </svg>
                        </div> : <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
                            <div className="cardBox">
                                <h4>{isEditing === true ? "Update Job Listing" : "Create Job Listing"}</h4>
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Title : <span class="requiredAstric"> *</span></label>
                                        <input type="text"  {...register("Title", { required: true })} className="border mb-2" placeholder="Title" aria-invalid={errors.Title ? "true" : "false"} />
                                        {errors.Title?.type === 'required' && <p className="text-danger" role="alert"> Title is required</p>}
                                    </div>
                                    <div className="col-md-6">
                                        <label>Location : <span class="requiredAstric"> *</span></label>
                                        <input type="text"  {...register("Location", { required: true })} className="border mb-2" placeholder="Location" aria-invalid={errors.Location ? "true" : "false"} />
                                        {errors.Location?.type === 'required' && <p className="text-danger" role="alert"> Location is required</p>}
                                    </div>
                                    <div className="col-md-6">
                                        <label>Number Of Positions : <span class="requiredAstric"> *</span></label>
                                        <input type="text"  {...register("NumberOfPositions", { required: true })} className="border mb-2" placeholder="Number Of Positions" aria-invalid={errors.NumberOfPositions ? "true" : "false"} />
                                        {errors.NumberOfPositions?.type === 'required' && <p className="text-danger" role="alert"> Number Of Positions is required</p>}
                                    </div>
                                    <div className="col-md-6">
                                        <label>Job Type : <span class="requiredAstric"> *</span></label>
                                        <input type="text"  {...register("JobType", { required: true })} className="border mb-2" placeholder="JobType" aria-invalid={errors.JobType ? "true" : "false"} />
                                        {errors.JobType?.type === 'required' && <p className="text-danger" role="alert"> Job Type is required</p>}
                                    </div>
                                    <div className="col-md-6">
                                        <label>Minimum Qualifications : <span class="requiredAstric"> *</span></label>
                                        <input type="text"  {...register("MinimumQualifications", { required: true })} className="border mb-2" placeholder="Minimum Qualifications" aria-invalid={errors.MinimumQualifications ? "true" : "false"} />
                                        {errors.MinimumQualifications?.type === 'required' && <p className="text-danger" role="alert"> Minimum Qualifications is required</p>}
                                    </div>
                                    <div className="col-md-6">
                                        <label>Contact Info : <span class="requiredAstric"> *</span></label>
                                        <input type="text"  {...register("ContactInfo", { required: true })} className="border mb-2" placeholder="Contact Info" aria-invalid={errors.ContactInfo ? "true" : "false"} />
                                        {errors.ContactInfo?.type === 'required' && <p className="text-danger" role="alert"> Contact Info is required</p>}
                                    </div>
                                    <div className="col-md-6">
                                        <label>Open Date : {isEditing === true ? < span class="requiredAstric"> *</span> : ''}</label>
                                        <input type="date" className="border col-md-12" {...register("OpenDate", { required: true })} placeholder="Open Date"></input>
                                        {errors.OpenDate?.type === 'required' && <p className="text-danger" role="alert"> OpenDate is required</p>}
                                    </div>
                                    <div className="col-md-6">
                                        <label>Close Date : {isEditing === true ? < span class="requiredAstric"> *</span> : ''}</label>
                                        <input type="date" className="border col-md-12" {...register("CloseDate", { required: true })} placeholder="Close Date"></input>
                                        {errors.CloseDate?.type === 'required' && <p className="text-danger" role="alert"> Close Date is required</p>}
                                    </div>
                                    <div className="col-md-6">
                                        <label>Url : <span class="requiredAstric"> *</span></label>
                                        <input type="text"  {...register("URL", { required: true })} className="border mb-2" placeholder="URL" aria-invalid={errors.URL ? "true" : "false"} />
                                        {errors.URL?.type === 'required' && <p className="text-danger" role="alert"> URL is required</p>}
                                    </div>
                                    <div className="col-md-12">
                                        <label>Description : {isEditing === true ? < span class="requiredAstric"> *</span> : ''}</label>
                                        <textarea className="border" {...register("Description", { required: true })} placeholder="Description"></textarea>
                                        {errors.Description?.type === 'required' && <p className="text-danger" role="alert"> Description is required</p>}
                                        </div>
                                        <div className="col-md-12 d-flex justify-content-end mt-3">
                                            <div>
                                                <button className="btn btnSave mt-2">Save</button>
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </form>}

                    </div>
                </div> : ''}

            </DashboardWrapper>
        </>
    )
}

export default DashboardJobListing;